import { ChartTypeConfig } from './ChartTypeConfig';
import { SeriesType } from '../utils/SeriesType';
import { BasicChart, SeriesOption } from '../utils/models';
import { ChartConfig } from './ChartConfig';



export class PieChartConfig extends ChartConfig implements ChartTypeConfig {
  getConfig(categories: string[], data: SeriesOption[], colors: string[]): Partial<BasicChart> {
    //console.log(categories);
    //console.log(data);

    const seriesRawData = data[0]?.data ?? [];

    const seriesData = seriesRawData.map((point: any, index: number) => {
      const value = typeof point === 'object' ? +point.value : +point;
      const name = categories[index] ?? `Item ${index + 1}`;
      const itemStyle = {color:colors[index % colors.length], ...point.itemStyle}; // safely cycle through colors if not enough

      return {
        name,
        value,
        ...(typeof point === 'object' ? point : {}),
        itemStyle
      };
    });
    //console.log(seriesRawData.reduce((sum, p) => sum + (typeof p === 'object' ? +p.value : p), 0));

    return {
      legend: {
        data: categories,
      },
      series: [
        {
          type: SeriesType.Pie,
          radius: ['20%', '50%'],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 10,
            borderColor: '#fff',
            borderWidth: 2,
          },
          label: {
            show: false,
          },
          labelLine: {
            show: false,
          },
          data: seriesData,
        },
      ],
      grid: {
        top: 30,
        bottom: 20,
        left: 30,
        right: 20,
        containLabel: true,
      },
    };
  }
}
